export enum MessageTemplateName {
    LoginLayout = 'Templates.LoginLayout',
}
